// CartWidgetItems.jsx

import React, {
  useContext,
  useMemo,
} from "react";

import { useDispatch } from "react-redux";

import classes from "./CartWidgetItems.module.css";

import ToastContext from "../../../../../store/context/toast-context";

import { deleteItemFromCart } from "../../../../../store/redux/cart/cart-actions";

import {
  getBucketUrl,
  getPrice,
} from "../../../../../utils/GeneralFunc";

import {
  getProductImage,
  getProductPrice,
  getVariantText,
} from "../../../../../utils/productUtils";

import { getEffectivePrice } from "../../../../../utils/priceUtils";
import Image from "../../../../../components/common/image";
import { useCurrency } from "../../../../../hooks/use-currency";

const CartWidgetItems = ({
  item,
}) => {
  const dispatch = useDispatch();
    const { formatPrice } = useCurrency();

  const toastCtx =
    useContext(ToastContext);

  const effectivePrice =
    useMemo(() => {
      return item?.productSkuResponse
        ? getEffectivePrice(
            item.productSkuResponse,
          )
        : null;
    }, [item]);

  const productPrice =
    useMemo(() => {
      return getProductPrice(
        item,
        null,
        effectivePrice,
      );
    }, [item, effectivePrice]);

  const productImage =
    useMemo(() => {
      return getProductImage(item);
    }, [item]);

   

  const variantText =
    useMemo(() => {
      return getVariantText(item);
    }, [item]);

  const deleteCartWItemHandler =
    () => {
      dispatch(
        deleteItemFromCart(
          item?.cartDetailId,
        ),
      );

      toastCtx.open(
        "Deleted successfully!",
      );
    };

  return (
    <li
      className={
        classes["cart-Wigdet-item"]
      }
    >
      <figure>
        <div
          className={
            classes[
              "cart-Wigdet_show"
            ]
          }
        >
          <div
            className={
              classes[
                "cart-Wigdet-img"
              ]
            }
          >
             <Image
                src={productImage}
                alt={item?.productName}
                className={classes.productImage}
              />
            
          </div>
        </div>

        <figcaption>
          <div
            className={
              classes[
                "cart-Wigdet-title"
              ]
            }
          >
            {item?.productName}
          </div>

          {variantText && (
            <div
              className={
                classes[
                  "cart-Wigdet-variant"
                ]
              }
            >
              {variantText}
            </div>
          )}

          <span>
            x{item?.productQty || 1}
          </span>

          <div
            className={
              classes[
                "cart-Wigdet-details"
              ]
            }
          >
            <span
              className={
                classes[
                  "cw-item-price"
                ]
              }
            >
              {formatPrice(
                productPrice,
              )}
            </span>

            <ion-icon
              data_nmi="trash_ico"
              onClick={
                deleteCartWItemHandler
              }
              name="trash-outline"
            />
          </div>
        </figcaption>
      </figure>
    </li>
  );
};

export default React.memo(
  CartWidgetItems,
);
